import { RESET_STORE } from "client/services/constants"
import { RESET_SURVEY_STORE } from "containers/Survey/services/constants"
import { PreventionHandoffStore } from "types/store"

import {
  PREVENTION_HANDOFF_CREATE_REQUEST,
  PREVENTION_HANDOFF_CREATE_SUCCESS,
  PREVENTION_HANDOFF_FAILURE,
  PREVENTION_HANDOFF_STATUS_SUCCESS,
  RESET_PREVENTION_HANDOFF,
} from "./constants"

const INITIAL: Partial<PreventionHandoffStore> = {
  loading: false,
  success: false,
  link: undefined,
  status: undefined,
}

const reducer = (state = INITIAL, action: any): Partial<PreventionHandoffStore> => {
  switch (action.type) {
    case PREVENTION_HANDOFF_CREATE_REQUEST:
      return { ...INITIAL, loading: true }
    case PREVENTION_HANDOFF_CREATE_SUCCESS:
      return { ...state, loading: false, success: true, link: action.payload, status: action.payload.status }
    case PREVENTION_HANDOFF_FAILURE:
      return { ...state, loading: false, success: false }
    case PREVENTION_HANDOFF_STATUS_SUCCESS:
      return { ...state, status: action.payload }
    case RESET_PREVENTION_HANDOFF:
    case RESET_SURVEY_STORE:
    case RESET_STORE:
      return { ...INITIAL }
    default:
      return state
  }
}

export default reducer
